import React, {FC, useRef} from 'react'
import {FormCheckType} from 'react-bootstrap/FormCheck'
import _ from 'lodash'
import {FormikProps, getIn} from 'formik'
import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'

type Props = {
  type?: FormCheckType
  className?: any
  required?: boolean
  label?: any
  labelClassName?: any
  inputClassName?: any
  checked?: any
  disabled?: boolean
  formik: FormikProps<any>
  name?: any
  value?: any
  onClick?: any
}

const AcceptTermCheckboxFormik: FC<Props> = ({
  type = 'checkbox',
  className,
  label,
  labelClassName,
  inputClassName,
  checked,
  disabled = false,
  formik,
  name,
  onClick,
}) => {
  const {current: id} = useRef(_.uniqueId('input-check'))
  let fieldProps = formik.getFieldProps(name)
  const formikErrors = getIn(formik.errors, name)
  const formikTouched = getIn(formik.touched, name)

  return (
    <div className={className}>
      <div
        className={clsx({
          'form-check d-flex align-items-center gap-2 ps-0': label,
          'form-switch': type === 'switch',
          'cursor-no-drop': disabled,
        })}
      >
        <input
          id={id}
          checked={checked ?? fieldProps.value}
          aria-label='check'
          aria-invalid={!!(formikTouched && formikErrors)}
          className={clsx(
            'form-check-input cursor-pointer flex-shrink-0 float-none mt-0 ms-0',
            inputClassName,
            {
              'is-invalid': formikTouched && formikErrors,
            }
          )}
          type={type === 'switch' ? 'checkbox' : type}
          disabled={disabled}
          {...fieldProps}
          onClick={onClick}
        />
        {label && (
          <label
            htmlFor={id}
            className={`form-check-label form-label mb-0 flex-grow-1 ${labelClassName}`}
          >
            {label}
          </label>
        )}
      </div>
      {formikTouched && formikErrors && (
        <div className='fv-plugins-message-container mt-2'>
          <div className='fv-help-block text-danger'>
            <img alt='err' src={toAbsoluteUrl('/media/gori/invalid.svg')} width={16} height={20} />
            <span className={'ms-1'} role='alert'>
              {formikErrors}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export {AcceptTermCheckboxFormik}
